import 'multiselect/css/multi-select.css';
import 'multiselect';




// WEBPACK FOOTER //
// ./webpack/assets/javascripts/bundle_multiselect.js